import { METRIC_NAME, JS_SERVER_TYPE } from '@/constants';
import { getAntiIn, monitorSingleJsLoadTime } from '@/utils';
import { smartReport } from '@/utils/metricHelper';

function waitForAntiIn(timeout = 5000): Promise<void> {
    return new Promise((resolve, reject) => {
        if (window.AntiIn) { resolve(); return; }
        const start = Date.now();
        const timer = setInterval(() => {
            if (window.AntiIn) {
                clearInterval(timer);
                resolve();
            } else if (Date.now() - start > timeout) {
                clearInterval(timer);
                reject(new Error('AntiIn load timeout'));
            }
        }, 50);
    });
}

export function entry(data: typeof import('@/constants')['DEFAULT_ANTI_SPIDER']['anti_in'], extra: { server_type: keyof typeof import('@/constants')['SERVER_TYPE']['production'], env: keyof typeof import('@/constants')['DEBUG_ENV'] }) {
    const { url } = data
    waitForAntiIn()
        .then(() => {
            smartReport({
                metric_name: METRIC_NAME,
                tags: { url, type: 'loadAntiIn' },
                value: 1,
                message: 'anti-in load success',
            })
        }).then(() => {
            monitorSingleJsLoadTime('antiin', JS_SERVER_TYPE[extra.env][extra.server_type]);
        })
        .catch(error => {
            smartReport({
                metric_name: METRIC_NAME,
                tags: { url, type: 'loadAntiInError' },
                value: 1,
                message: 'anti-in load error',
                params: { msg: error?.message, stack: error?.stack }
            })
        })
}

export async function headerOpenController(self: XMLHttpRequest, url: string, data: typeof import('@/constants')['DEFAULT_ANTI_SPIDER']['anti_in']) {
    if (data?.hit?.some(path => url.includes(path))) {
        self._customHeaders = {
            ...self._customHeaders,
            'anti-in': 'anti-in'
        };
    }
}

export async function headerSendController(self: XMLHttpRequest) {
    if (self?._customHeaders?.['anti-in']) {
        self.setRequestHeader('anti-in', getAntiIn());
    }
}

export function provideAntiIn() {
    try {
        const anti_in = getAntiIn();
        smartReport({
            metric_name: METRIC_NAME,
            tags: { type: 'loadAntiIn', url: 'shein' },
            value: 1,
            message: 'antiin load success',
        })
        return anti_in || ''
    } catch (error) {
        smartReport({
            metric_name: METRIC_NAME,
            tags: { type: 'loadAntiInError', url: 'shein' },
            value: 1,
            message: 'antiin load error',
            params: error
        })
    }
    return ''
}